// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1642":"31d6cfe0","2161":"31d6cfe0","2341":"31d6cfe0","2744":"31d6cfe0","3009":"2c0b0634"}[chunkId] + ".chunk.css";
};